import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.slug}`}
      className="group block rounded-xl overflow-hidden bg-background-200/60 hover:bg-background-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 91高清视频在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 shadow-lg">
            <i className="ri-play-fill text-foreground-950 text-2xl ml-1"></i>
          </div>
        </div>
        <span className="absolute bottom-2 right-2 bg-background-50/80 backdrop-blur-sm text-foreground-800 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
          {video.duration}
        </span>
        <span className="absolute top-2 left-2 bg-primary-500 text-foreground-950 text-xs font-semibold px-2 py-0.5 rounded-md whitespace-nowrap">
          {video.quality}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-foreground-900 font-medium text-sm leading-snug line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {video.title}
        </h3>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
            </div>
            <span className="text-accent-500 text-xs font-semibold">{video.rating}</span>
          </div>
          <span className="text-foreground-400 text-xs whitespace-nowrap">
            {video.views.toLocaleString()} 次播放
          </span>
        </div>
      </div>
    </Link>
  );
}